var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheeks = function SvgCheeks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 33,
    viewBox: "0 0 0.62 0.75",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2313179040448"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.37.07C.14 0 0 .18.08.42c.04.11.1.23.18.27.09.04.3-.13.3-.29C.56.24.52.12.37.07z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M.09.29C.09.34.1.4.11.42c.02.05.04.09.07.13C.19.54.2.54.2.53.32.46.21.32.09.29zM.46.56C.5.51.53.45.53.4.53.37.52.33.52.3.41.34.32.46.42.53c.02.01.03.02.04.03z"
  })))));
};

export default SvgCheeks;